import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Calendar, Mail, Video, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Countdown from "../components/Countdown";
import { EVENT, ASSETS } from "../mock";

const NEXT_STEPS = [
  { icon: Mail, title: "Check Your Inbox", body: "A confirmation with the session details is on its way. Add it to your calendar so you don't miss it." },
  { icon: Calendar, title: "Mark the Date", body: "September 15th, 2026 at 6:00 PM PST. The live briefing runs 45 minutes, plus live Q&A." },
  { icon: Video, title: "Show Up Live", body: "Bring your questions. If you can't make it, registrants receive the follow-up materials and replay access." },
];

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#070b16] min-h-screen" data-testid="thank-you-page">
      <Navbar />
      <section className="relative overflow-hidden pt-36 pb-24">
        <div className="absolute inset-0 bg-cover bg-center opacity-[0.1]" style={{ backgroundImage: `url(${ASSETS.blueprint})` }} />
        <div className="absolute inset-0 blueprint-grid opacity-20" />
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle2 size={52} className="text-[#6b9be8]" />
          </div>
          <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-4">Registration Confirmed</p>
          <h1 className="font-heading uppercase text-white text-4xl sm:text-6xl leading-[0.95] tracking-tight" data-testid="thank-you-headline">
            You're In. Your Seat Is <span className="text-[#6b9be8]">Reserved.</span>
          </h1>
          <p className="mt-6 text-[#aeb9d4] leading-relaxed max-w-xl mx-auto">
            The live briefing takes place on <span className="text-white">{EVENT.dateLabel.toLowerCase()}</span>. No loan
            application, no hard credit pull, no obligation — just 45 minutes that show you your exact $0-down VA
            purchasing power.
          </p>
          <div className="mt-10 flex justify-center">
            <Countdown target={EVENT.targetDate} />
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid sm:grid-cols-3 gap-3">
            {NEXT_STEPS.map((s, i) => (
              <div key={s.title} className="card-hover border border-[#1c2740] bg-[#0c1324]/60 p-7">
                <s.icon size={22} className="text-[#6b9be8] mb-5" />
                <p className="font-mono text-[9px] tracking-[0.3em] text-[#5c6a8c] uppercase mb-2">STEP 0{i + 1}</p>
                <h3 className="font-heading uppercase text-white text-lg tracking-tight mb-3">{s.title}</h3>
                <p className="text-[#8fa0c0] text-sm leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 border border-[#22304e] bg-[#0c1324]/80 p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <img src={ASSETS.oscar} alt="Oscar Tobar" className="w-14 h-14 object-cover border border-[#22304e]" />
              <div>
                <p className="text-white text-sm font-semibold">{EVENT.host}</p>
                <p className="text-[#7f8db0] text-xs">{EVENT.company} · {EVENT.nmls}</p>
                <p className="text-[#7f8db0] text-xs mt-1">Questions before the session? <a href={`mailto:${EVENT.email}`} className="text-[#9db8e8] underline">{EVENT.email}</a></p>
              </div>
            </div>
            <Link
              to="/replay"
              data-testid="thank-you-replay-link"
              className="cta-glow flex items-center gap-2 border border-[#3f639f] text-[#9db8e8] hover:bg-[#3f639f] hover:text-white font-mono text-xs tracking-[0.25em] uppercase px-6 py-3.5"
            >
              Replay Page <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ThankYou;
